// map extracted fields to data view based on context type
import { mapBusinessCardExtractedFieldsToDataView } from "./mapBusinessCardExtractedFieldsToDataView";
import { mapCOIExtractedFieldsToDataView } from "./mapCOIExtractedFieldsToDataView";
import { mapDriversLicenseExtractedFieldsToDataView } from "./mapDriversLicenseExtractedFieldsToDataView";
import { mapResumeExtractedFieldsToDataView } from "./mapResumeExtractedFieldsToDataView";

import { DataItemProps } from "../../../../../../shared/components/DataView";
import { SharedFileRequestContextType } from "@wingspanhq/shared-files/dist/lib/interfaces/sharedFileRequest";

export const mapContextTypeExtractedFieldsToDataView = (
  extractedFields: any,
  contextType: SharedFileRequestContextType | undefined
): DataItemProps[] => {
  switch (contextType) {
    case SharedFileRequestContextType.BusinessCard:
      return mapBusinessCardExtractedFieldsToDataView(extractedFields);
    case SharedFileRequestContextType.DriversLicense:
      return mapDriversLicenseExtractedFieldsToDataView(extractedFields);
    case SharedFileRequestContextType.Resume:
      return mapResumeExtractedFieldsToDataView(extractedFields);
    case SharedFileRequestContextType.GeneralLiabilityCertificateOfInsurance:
      return mapCOIExtractedFieldsToDataView(extractedFields);
    case SharedFileRequestContextType.WorkersCompCertificateOfInsurance:
      return mapCOIExtractedFieldsToDataView(extractedFields);
    default:
      return [];
  }
};
